export function adminApiBaseUrl(): string {
  return (
    configuredAdminApiBaseUrl() ??
    inferredHostedAdminApiBaseUrl() ??
    browserOrigin() ??
    "http://localhost"
  );
}

export function adminApiUrl(path: string): string {
  return new URL(path, adminApiBaseUrl()).toString();
}

function configuredAdminApiBaseUrl(): string | null {
  return firstNonEmptyValue(
    import.meta.env.VITE_PRICE_RESCUE_API_BASE_URL,
    import.meta.env.VITE_API_BASE_URL,
  );
}

function firstNonEmptyValue(...values: Array<string | undefined>): string | null {
  for (const value of values) {
    if (value !== undefined && value.trim().length > 0) {
      return value;
    }
  }

  return null;
}

function browserOrigin(): string | null {
  return globalThis.location?.origin ?? null;
}

function inferredHostedAdminApiBaseUrl(): string | null {
  const origin = browserOrigin();
  if (origin === null) {
    return null;
  }

  const url = new URL(origin);
  if (url.hostname === "price-rescue-admin-dev.techyelp.com") {
    return "https://price-rescue-api-dev.techyelp.com";
  }

  if (url.hostname === "price-rescue-admin.techyelp.com") {
    return "https://price-rescue-api.techyelp.com";
  }

  return null;
}
